export interface BatchSchoolUserListRequest {
  gradeCode: string
  classCode: string
  order: string
  batchType: string
}

export function BatchSchoolUserListRequestToJSON(
  value: BatchSchoolUserListRequest
): any {
  return {
    grade_code: value.gradeCode,
    class_code: value.classCode,
    order: value.order,
    batch_type: value.batchType
  }
}
